export const CUSTOM_EVENTS_NAMES = {
  historyReplaceState: 'custom-history-replace-state-event',
};
